import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { MyContext } from '../Context/MyProvider';
import Logo from "../assets/Icon/applogo.svg";
import PlayLogo from "../assets/Image/PlayStore.png";
import AppLogo from "../assets/Image/AppStore.png";
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    const { pagList, siteTitle, lightLogo, BaseUrl } = useContext(MyContext);

    const GetDate = new Date();

    return (
        <div className='bg-black py-10'>
            <div className="max-w-7xl mx-auto px-4">

                {/* Top Section */}
                <div className="flex flex-col md:flex-row justify-between gap-10 pb-10">

                    {/* Left */}
                    <div className="md:w-1/2 text-white">
                        <Link to="/" className="flex items-center gap-2">
                            <img src={lightLogo ? (BaseUrl + lightLogo) : Logo} alt="Logo" className="h-8 w-auto object-contain" />
                        </Link>

                        <p className='mt-3 text-sm leading-6'>
                            {t("Build better products with flexible tools, helpful documentation")}
                            <br />
                            {t("and a team that champions your growth.")}
                        </p>
                    </div>

                    {/* Right */}
                    <div className="md:w-1/2 flex flex-col sm:flex-row gap-10 text-white">

                        {/* Useful Links */}
                        <div className="sm:w-1/2 flex sm:justify-end">
                            <div className="">
                                <h1 className='uppercase font-bold text-base'>{t("Useful Link")}</h1>
                                <ul className="mt-3 space-y-2">
                                    {pagList?.map((item, index) => {
                                        const Title = item.title.replace(/\s+/g, '-').toLowerCase();
                                        return (
                                            <li key={index} className='hover:underline'>
                                                <Link to={`/pages/${Title}`}>{item.title}</Link>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>

                        {/* Social / Apps */}
                        <div className="sm:w-1/2 flex sm:justify-end">
                            <div className="">
                                <h1 className='uppercase font-bold text-base'>{t("Socials")}</h1>
                                <ul className='mt-3 space-y-3'>
                                    <li>
                                        <Link to="https://play.google.com/" target="_blank">
                                            <img src={PlayLogo} className='w-36 border rounded-md' alt="PlayStoreLogo" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://apps.apple.com/" target="_blank">
                                            <img src={AppLogo} className='w-36 border rounded-md' alt="AppStoreLogo" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                </div>

                {/* Bottom Section */}
                <div className="border-t border-gray-700 pt-6 text-center text-white text-sm">
                    {t("footer_title", { getFullYear: GetDate.getFullYear() })}
                </div>

            </div>
        </div >
    )
}

export default Footer;